// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"929":"96e00c3a","1873":"17c5d51c","5906":"17c5d51c","6048":"13928f46"}[chunkId] + ".css";
};